import { Loader } from 'components/loader/Loader';
import { StatisticsByAccessControlTable } from './StatisticsByAccessControlTable';
import { useAppSelector } from 'redux/hooks';
import { useNavigate } from "react-router-dom";

export const StatisticsByAccessControl = () => {
    const loadingState = useAppSelector(state => state.statistics.tokensWithoutEventsLoadingState);
    const isLoading = loadingState === 'NotLoaded' || loadingState === 'Loading';

    const navigate = useNavigate();

    const handleNavigate = () => {
    navigate("/statistics");
    };

    return (
        <main className="main">
            <div className="wrap">
                <div className="intro intro--stats">
                    <button type="button" onClick={handleNavigate} className="link link--icon link--arrow-left">
                        Back
                    </button>
                    <h1 className="intro__title">Statistics by <span className="intro__title-highlight">Access control system</span></h1>
                </div>
                <div className="manager">
                    {isLoading && <Loader />}
                    <StatisticsByAccessControlTable />
                    {null}
                </div>
            </div>
        </main>
    )
};
